import React from 'react';

const unwidow = (str) => {
  if (typeof str !== `string`) {
    return str;
  }
  const splitStr = str.split(` `);
  return (
    <>
      {splitStr.slice(0, -1).join(` `)}&nbsp;{splitStr.slice(-1)}
    </>
  );
};

export default unwidow;
